{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/TIMED_GET_UP_AND_GO",
	"name": "TIMED_GET_UP_AND_GO",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Timed Get Up and Go",
	"purpose": "Meet de mobiliteit en het valrisico op basis van risicofactoren",
	"description": "Het meten van de tijd(in seconden) die nodig is om op te staan uit een stoel, in een comfortabel tempo 3 meter te lopen, om te keren, weer terug te lopen en te gaan zitten.",
	"item": [
		{
			"linkId": "638-instructions",
			"text": "De te onderzoeken patiënt zit op een stoel met een rugleuning en de armen steunen op de armleuningen. Hij wordt verzocht recht te staan, drie meter te wandelen tot aan een lijn of een merkteken, zich 180° om te draaien, terug te komen naar de stoel en te gaan zitten. Het gebruik van een hulpmiddel (bijvoorbeeld een wandelstok of een looprek) is toegestaan. De patiënt mag dat hulpmiddel met de handen vasthouden bij het begin van de test. Het begin en het einde van de tijd wordt gemeten wanneer de patiënt met de rug tegen de rugleuning van de stoel zit. Een praktische proef is aanbevolen om de patiënt vertrouwd te maken met de test.",
			"type": "display"
		},
		{
			"linkId": "90200",
			"text": "Hoeveel seconden duurt het om de Timed Get Up and Go uit te voeren?",
			"type": "integer",
			"required": true,
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-unit",
					"valueCoding": {
						"system": "http://unitsofmeasure.org",
						"code": "s",
						"display": "seconds"
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/minValue",
					"valueInteger": 1
				}
			]
		}
	]
}
